/**
 * [INPUT]: 依赖 React context/use，消费当前 series 的 dataKey、seed 与 dimmed 状态
 * [OUTPUT]: 对外提供 SeriesContext 与 useSeries 边界守卫
 * [POS]: Dot/ActiveDot 等 series 子件的局部上下文，避免从全局根重复查找
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
import { createContext, use } from "react"

export const SeriesContext = createContext(null)

/** Boundary guard for series-scoped markers (`<Dot>`, `<ActiveDot>`). */
export function useSeries(part) {
  const ctx = use(SeriesContext)
  if (!ctx) {
    throw new Error(`<${part} /> must be rendered inside a series (e.g. <Area />).`)
  }
  return ctx
}
